/** @format */

import React from 'react';
import { useTranslation } from 'react-i18next';

export function EventsWidget({ data }) {
  const { t } = useTranslation();
  return (
    <div className="events-widget" data-width={data.w} data-height={data.h}>
      <div className="events-widget--title">
        <h2>{data.title}</h2>
      </div>
      {data.data && (
        <div className="events-widget--list-wrapper">
          <div className="events-widget--list">
            {data.data.length > 0 ? (
              data.data.map(({ id, title, date, category, text }) => (
                <div className="events-widget--list-item" key={id}>
                  <div className="events-widget--list-item-image"></div>
                  <div className="events-widget--list-item-right">
                    <div className="events-widget--list-item-title">{title}</div>
                    <div className="events-widget--list-item-date-category">
                      <div className="events-widget--list-item-date">{date || '00.00.0000'}</div>
                      <div className="events-widget--list-item-category">{category || 'category'}</div>
                    </div>
                    <div className="events-widget--list-item-text">{text}</div>
                  </div>
                </div>
              ))
            ) : (
              <p className="events-widget--list-empty">{t('widget.noEvents')}</p>
            )}
          </div>
        </div>
      )}
      <div className="events-widget--link">
        <a href="/events">{t('widget.allEvents')}</a>
      </div>
    </div>
  );
}
